import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { initXLog } from '@/common/utils/xLogManager';

Vue.use(ElementUI);
Vue.config.productionTip = false;

let instance: any = null;
instance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


declare global {
  interface Window {
    XLog: any;
    MSInputMethodContext: any;
  }
  interface Document {
    documentMode: any;
  }
}
// 初始化监控
initXLog();